import React from "react";
import { useInView } from "react-intersection-observer";
import ProgressiveBackgroundImg from "../ProgressiveBackgroundImg/ProgressiveBackgroundImg";

const TsThumbComponent = ({projItem, p_idx}) => {
    return(
        <>
            <div className="ts-test" >
                {
                    projItem !== null &&
                    <ProgressiveBackgroundImg
                        key={"progressive-"+p_idx}
                        placeholderSrc={projItem.thumbnails.placeholder}
                        src={projItem.thumbnails.mobile}
                        idx={p_idx}
                        isFirefox={false}
                        forceObjectFit={true}
                    />
                }
            </div>
        </>
    )
}

export default TsThumbComponent;